<template>
  <es-loader
    v-if="loading"
    style="margin: 6.5rem"
  />
  <es-exception
    v-else-if="loadingError"
    style="padding: 6.5rem"
    margin="0rem" size="4x"
    exceptionMessage="There was an issue. Please contact the admin"
  />
  <div v-else>
    <template>
      <div
        v-if="showModal"
        class="modal is-active"
        role="dialog"
        aria-label="Confirm a not duplicate Decision"
        aria-hidden="false"
      >
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">
              <strong>Confirm Decision</strong>
            </p>
            <button
              class="icon is-right"
              @click.prevent="toggleModal()"
              ref="closeIcon"
            >
              <font-awesome-icon :icon="['fal', 'times']" title="Close" />
            </button>
          </header>
          <section class="modal-card-body">
            <div class="modal-body">
              Are you sure you want to make a "Not Duplicate" decision for this record?
            <br/>
            <br/>
            </div>
            <div class="update-box">
              <button @click.prevent="toggleModal()"
                class="button button-link has-underline"
              >
                Cancel
              </button>
              <button
                class="button is-primary"
                @click="removeFromList()"
              >
                Yes Not Duplicate
              </button>
            </div>
          </section>
        </div>
      </div>
    </template>
    <div class="document">
      <div class="header">
        <es-header>
          <template #header>
            <div class="header-title">
              Review Retire/Merge ID Details
            </div>
          </template>
        </es-header>
      </div>
      <es-exception
        v-if="differentPersonTypes"
        style="padding: 6.5rem"
        margin="0rem"
        exceptionMessage="The identifier retirement request is not authorized.
          The identifiers are not the same person type and cannot be merged."
      />
      <es-exception
        v-else-if="loadingIdError"
        style="padding: 6.5rem"
        margin="0rem" size="4x"
        :exceptionMessage="loadingIdErrorMsg"
      />
      <div v-else>
        <div class="overflow-container" style="padding: 1rem">
          <div class="outer">
            <div
              v-if="retiredConfirmation
              && showMatchingFields"
            >
              <span
                v-if="mergeStudent"
                class="float-text"
                style="left: 33%"
              >
                (RETIRED)
              </span>
              <span
                v-else
                class="float-text"
                style="left: 53%"
              >
                (RETIRED)
              </span>
            </div>
            <table class="table">
              <thead>

                <tr v-if="retiredConfirmation">
                  <th scope="col" style="border: 0"/>
                  <th scope="col" class="label-retire">
                    RETIRED ID
                  </th>
                  <th
                    v-if="mergeStudent"
                    scope="col"
                    class="blank-column icon-cell"
                  >
                    <font-awesome-icon :icon="['fas', 'merge']" size="lg"/>
                    <div style="font-size: 10px">
                      MERGED TO
                    </div>
                  </th>
                  <th
                    v-if="mergeStudent"
                    scope="col"
                    class="label-merge"
                    :class="{ 'border-green': retiredConfirmation}"
                  >
                    ID RETAINED / MERGED INTO
                  </th>
                </tr>
                <tr v-else>
                  <th scope="col" style="border: 0"/>
                  <th class="label-retire" scope="col">
                    ID TO BE RETIRED
                  </th>
                  <th
                    v-if="mergeStudent"
                    scope="col"
                    class="blank-column icon-cell"
                  >
                    <font-awesome-icon :icon="['fas', 'merge']" size="lg"/>
                    <div style="font-size: 10px">
                      MERGED TO
                    </div>
                  </th>
                  <th
                    v-if="mergeStudent"
                    scope="col"
                    class="label-merge"
                  >
                    ID TO BE RETAINED / MERGED INTO
                  </th>
                </tr>
                <tr>
                  <td class="compare-panel vertical-align--initial"/>
                  <td class="compare-panel border--left">
                    <div class="is-flex flex-direction--column flex-align--center">
                      <div>
                        <span class="state-id-label">
                          STATE ID :
                        </span>
                        <span class="state-id">
                          <strong>
                            {{
                              formatStateID(retireStudent.stateStudentId
                                ? retireStudent.stateStudentId
                                : retireStudent.personId)
                            }}
                          </strong>
                        </span>
                      </div>
                      <button
                        v-if="mergeStudent && !retiredConfirmation"
                        class="button button-link has-underline"
                        :disabled="loadingIdError || !hasRetireIdNoMergePermission"
                        @click='goToConfirmationPage(false)'
                      >
                        Retire ID with No Merge
                      </button>
                    </div>
                  </td>
                  <td
                    v-if="mergeStudent"
                    class="blank-column border--left switch-label"
                  >
                    <button
                      v-if="!retiredConfirmation"
                      @click="switchTheData"
                      :disabled="!hasRetireIdMergePermission || !hasRetireIdNoMergePermission"
                      class="button button-link has-underline"
                    >
                      <strong>Switch Records</strong>
                    </button>
                  </td>
                  <td
                    v-if="mergeStudent"
                    class="compare-panel border--left"
                    :class="{ 'border-green': retiredConfirmation}"
                  >
                    <div
                      v-if="mergeStudentMarkedNoDup"
                      class="is-flex flex-direction--column"
                    >
                      <div>
                        <span class="state-id-label">
                          Select an ID to review:
                        </span>
                      </div>
                      <div class="select">
                        <select style="width: 100%" v-model="otherId">
                          <option
                            v-for="(item, id) in remainingIds"
                            :key="id"
                            :value="item"
                          >
                            {{ item }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div v-else class="is-flex flex-direction--column flex-align--center">
                      <div>
                        <span class="state-id-label">
                          STATE ID :
                        </span>
                        <span class="state-id">
                          <strong>{{ formatStateID(mergeStudent.stateStudentId) }}</strong>
                        </span>
                      </div>
                      <button
                        v-if="mergeStudent && !retiredConfirmation
                          && this.$route.query.search === 'queue'"
                        class="button button-link has-underline"
                        @click='toggleModal()'
                        ref="btnNoDup"
                      >
                        Not a Duplicate (Remove from List)
                      </button>
                    </div>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="compare-panel-heading-bg-color has-text-weight-bold">
                    Matching Fields
                  </td>
                  <td class="compare-panel-heading-bg-color text-align--center">
                    <font-awesome-icon
                      v-if="matchingFieldsInfoDifferent"
                      :icon="['fas', 'exclamation-circle']"
                      size="lg"
                      style="color: #D13241"
                    />
                    <div
                      v-if="!mergeStudent"
                      class="align--end"
                      >
                      <font-awesome-icon
                        v-if="showMatchingFields"
                        :icon="['far', 'caret-up']"
                        style="cursor: pointer; font-size: 1.25rem; color: #5953A4"
                        @click="toggleMatchingFields()"
                      />
                      <font-awesome-icon
                        v-else
                        :icon="['far', 'caret-down']"
                        size="lg"
                        style="cursor: pointer; font-size: 1.25rem; color: #5953A4"
                        @click="toggleMatchingFields()"
                      />
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column compare-panel-heading-bg-color"/>
                  <td
                    v-if="mergeStudent"
                    class="compare-panel-heading-bg-color right-column-icons"
                    :class="{ 'border-green': retiredConfirmation}"
                  >
                    <div></div>
                    <div>
                      <font-awesome-icon
                        v-if="matchingFieldsInfoDifferent"
                        :icon="['fas', 'exclamation-circle']"
                        size="lg"
                        style="color: #D13241"
                      />
                    </div>
                    <div>
                      <font-awesome-icon
                        v-if="showMatchingFields"
                        :icon="['far', 'caret-up']"
                        style="cursor: pointer; font-size: 1.25rem; color: #5953A4"
                        @click="toggleMatchingFields()"
                      />
                      <font-awesome-icon
                        v-else
                        :icon="['far', 'caret-down']"
                        size="lg"
                        style="cursor: pointer; font-size: 1.25rem; color: #5953A4"
                        @click="toggleMatchingFields()"
                      />
                    </div>
                  </td>
                </tr>
                <tr v-if="showMatchingFields && fieldEnabled('FIRST_NAME')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('FIRST_NAME') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.firstName, mergeStudent.firstName)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudent.firstName }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.firstName, mergeStudent.firstName)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudent.firstName }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showMatchingFields && fieldEnabled('MIDDLE_NAME')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('MIDDLE_NAME') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.middleName, mergeStudent.middleName)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudent.middleName }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.middleName, mergeStudent.middleName)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudent.middleName }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showMatchingFields && fieldEnabled('LAST_NAME')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('LAST_NAME') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.lastName, mergeStudent.lastName)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudent.lastName }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.lastName, mergeStudent.lastName)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudent.lastName }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showMatchingFields && fieldEnabled('SUFFIX')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('SUFFIX') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.suffix, mergeStudent.suffix)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudent.suffix }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.suffix, mergeStudent.suffix)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudent.suffix }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showMatchingFields && fieldEnabled('PREVIOUS_LAST_NAME')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('PREVIOUS_LAST_NAME') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudent.previousLastName, mergeStudent.previousLastName
                        ) : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudent.previousLastName }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudent.previousLastName, mergeStudent.previousLastName
                        ) : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudent.previousLastName }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showMatchingFields && fieldEnabled('GENDER_CODE')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('GENDER_CODE') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.genderCode, mergeStudent.genderCode)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ mapGender(retireStudent.genderCode) }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.genderCode, mergeStudent.genderCode)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mapGender(mergeStudent.genderCode) }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showMatchingFields && fieldEnabled('DATE_OF_BIRTH')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('DATE_OF_BIRTH') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.dateOfBirth, mergeStudent.dateOfBirth)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudent.dateOfBirth }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.dateOfBirth, mergeStudent.dateOfBirth)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudent.dateOfBirth }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showMatchingFields && fieldEnabled('SOCIAL_SECURITY_NUMBER')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('SOCIAL_SECURITY_NUMBER') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudent.socialSecurityNumber, mergeStudent.socialSecurityNumber
                        )
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudent.socialSecurityNumber }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudent.socialSecurityNumber, mergeStudent.socialSecurityNumber
                        )
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudent.socialSecurityNumber }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="compare-panel-heading-bg-color has-text-weight-bold">
                    Person Information
                  </td>
                  <td class="compare-panel-heading-bg-color text-align--center">
                    <font-awesome-icon
                      v-if="personInfoDifferent"
                      :icon="['fas', 'exclamation-circle']"
                      size="lg"
                      style="color: #D13241"
                    />
                    <div v-if="!mergeStudent" class="align--end">
                      <font-awesome-icon
                        v-if="showPersonInformation"
                        :icon="['far', 'caret-up']"
                        style="cursor: pointer; font-size: 1.25rem; color: #5953A4"
                        @click="togglePersonInformation()"
                      />
                      <font-awesome-icon
                        v-else
                        :icon="['far', 'caret-down']"
                        size="lg"
                        style="cursor: pointer; font-size: 1.25rem; color: #5953A4"
                        @click="togglePersonInformation()"
                      />
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column compare-panel-heading-bg-color"/>
                  <td
                    v-if="mergeStudent"
                    class="compare-panel-heading-bg-color right-column-icons"
                    :class="{ 'border-green': retiredConfirmation}"
                  >
                    <div></div>
                    <div>
                      <font-awesome-icon
                        v-if="personInfoDifferent"
                        :icon="['fas', 'exclamation-circle']"
                        size="lg"
                        style="color: #D13241"
                      />
                    </div>
                    <div>
                      <font-awesome-icon
                        v-if="showPersonInformation"
                        :icon="['far', 'caret-up']"
                        style="cursor: pointer; font-size: 1.25rem; color: #5953A4"
                        @click="togglePersonInformation()"
                      />
                      <font-awesome-icon
                        v-else
                        :icon="['far', 'caret-down']"
                        size="lg"
                        style="cursor: pointer; font-size: 1.25rem; color: #5953A4"
                        @click="togglePersonInformation()"
                      />
                    </div>
                  </td>
                </tr>
                <tr v-if="showPersonInformation && fieldEnabled('ETHNICITY_INDICATOR')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('ETHNICITY_INDICATOR') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudent.ethnicityIndicator, mergeStudent.ethnicityIndicator
                        )
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ mapEthnicity(retireStudent.ethnicityIndicator) }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudent.ethnicityIndicator, mergeStudent.ethnicityIndicator
                        )
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mapEthnicity(mergeStudent.ethnicityIndicator) }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showPersonInformation && fieldEnabled('RACE_ETHNIC_CODE')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('RACE_ETHNIC_CODE') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.raceEthnicCode, mergeStudent.raceEthnicCode)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ mapRace(retireStudent.raceEthnicCode) }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.raceEthnicCode, mergeStudent.raceEthnicCode)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mapRace(mergeStudent.raceEthnicCode) }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showPersonInformation && fieldEnabled('RACE2_CODE')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('RACE2_CODE') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.race2Code, mergeStudent.race2Code)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ mapRace(retireStudent.race2Code) }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.race2Code, mergeStudent.race2Code)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mapRace(mergeStudent.race2Code) }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showPersonInformation && fieldEnabled('RACE3_CODE')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('RACE3_CODE') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.race3Code, mergeStudent.race3Code)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ mapRace(retireStudent.race3Code) }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.race3Code, mergeStudent.race3Code)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mapRace(mergeStudent.race3Code) }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showPersonInformation && fieldEnabled('RACE4_CODE')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('RACE4_CODE') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.race4Code, mergeStudent.race4Code)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ mapRace(retireStudent.race4Code) }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.race4Code, mergeStudent.race4Code)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mapRace(mergeStudent.race4Code) }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showPersonInformation && fieldEnabled('RACE5_CODE')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('RACE5_CODE') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.race5Code, mergeStudent.race5Code)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ mapRace(retireStudent.race5Code) }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.race5Code, mergeStudent.race5Code)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mapRace(mergeStudent.race5Code) }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showPersonInformation && fieldEnabled('ETHNIC_SUB_GROUP')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('ETHNIC_SUB_GROUP') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.ethnicSubGroup, mergeStudent.ethnicSubGroup)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ mapEthnicSubGroup(retireStudent.ethnicSubGroup) }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.ethnicSubGroup, mergeStudent.ethnicSubGroup)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mapEthnicSubGroup(mergeStudent.ethnicSubGroup) }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showPersonInformation && fieldEnabled('FULL_NAME')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('FULL_NAME') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.fullName, mergeStudent.fullName)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudent.fullName }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.fullName, mergeStudent.fullName)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudent.fullName }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showPersonInformation && fieldEnabled('AKA_NAME')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('AKA_NAME') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.akaName, mergeStudent.akaName)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudent.akaName }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.akaName, mergeStudent.akaName)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudent.akaName }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="compare-panel-heading-bg-color has-text-weight-bold">
                    Contact Information
                  </td>
                  <td class="compare-panel-heading-bg-color text-align--center">
                    <font-awesome-icon
                      v-if="contactInfoDifferent"
                      :icon="['fas', 'exclamation-circle']"
                      size="lg"
                      style="color: #D13241"
                    />
                    <div v-if="!mergeStudent" class="align--end">
                      <font-awesome-icon
                        v-if="showContactInformation"
                        :icon="['far', 'caret-up']"
                        style="cursor: pointer; font-size: 1.25rem; color: #5953A4"
                        @click="toggleContactInformation()"
                      />
                      <font-awesome-icon
                        v-else
                        :icon="['far', 'caret-down']"
                        size="lg"
                        style="cursor: pointer; font-size: 1.25rem; color: #5953A4"
                        @click="toggleContactInformation()"
                      />
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column compare-panel-heading-bg-color"/>
                  <td
                    v-if="mergeStudent"
                    class="compare-panel-heading-bg-color right-column-icons"
                    :class="{ 'border-green': retiredConfirmation}"
                  >
                    <div></div>
                    <div>
                      <font-awesome-icon
                        v-if="contactInfoDifferent"
                        :icon="['fas', 'exclamation-circle']"
                        size="lg"
                        style="color: #D13241"
                      />
                    </div>
                    <div>
                      <font-awesome-icon
                        v-if="showContactInformation"
                        :icon="['far', 'caret-up']"
                        style="cursor: pointer; font-size: 1.25rem; color: #5953A4"
                        @click="toggleContactInformation()"
                      />
                      <font-awesome-icon
                        v-else
                        :icon="['far', 'caret-down']"
                        size="lg"
                        style="cursor: pointer; font-size: 1.25rem; color: #5953A4"
                        @click="toggleContactInformation()"
                      />
                    </div>
                  </td>
                </tr>
                <tr v-if="showContactInformation && fieldEnabled('STREET_1')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('STREET_1') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.street1, mergeStudent.street1)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudent.street1 }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.street1, mergeStudent.street1)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudent.street1 }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showContactInformation && fieldEnabled('STREET_2')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('STREET_2') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.street2, mergeStudent.street2)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudent.street2 }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.street2, mergeStudent.street2)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudent.street2 }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showContactInformation && fieldEnabled('CITY')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('CITY') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.city, mergeStudent.city)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudent.city }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.city, mergeStudent.city)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudent.city }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showContactInformation && fieldEnabled('STATE_CODE')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('STATE_CODE') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.stateCode, mergeStudent.stateCode)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ mapState(retireStudent.stateCode) }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.stateCode, mergeStudent.stateCode)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mapState(mergeStudent.stateCode) }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showContactInformation && fieldEnabled('ZIP')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('ZIP') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.zip, mergeStudent.zip)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudent.zip }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.zip, mergeStudent.zip)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudent.zip }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showContactInformation && fieldEnabled('GEOCODE')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('GEOCODE') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.geocode, mergeStudent.geocode)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudent.geocode }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.geocode, mergeStudent.geocode)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudent.geocode }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="compare-panel-heading-bg-color has-text-weight-bold">
                    Location Information
                  </td>
                  <td class="compare-panel-heading-bg-color text-align--center">
                    <font-awesome-icon
                      v-if="locationInfoDifferent"
                      :icon="['fas', 'exclamation-circle']"
                      size="lg"
                      style="color: #D13241"
                    />
                    <div v-if="!mergeStudent" class="align--end">
                      <font-awesome-icon
                        v-if="showLocationInformation"
                        :icon="['far', 'caret-up']"
                        style="cursor: pointer; font-size: 1.25rem; color: #5953A4"
                        @click="toggleLocationInformation()"
                      />
                      <font-awesome-icon
                        v-else
                        :icon="['far', 'caret-down']"
                        size="lg"
                        style="cursor: pointer; font-size: 1.25rem; color: #5953A4"
                        @click="toggleLocationInformation()"
                      />
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column compare-panel-heading-bg-color"/>
                  <td
                    v-if="mergeStudent"
                    class="compare-panel-heading-bg-color right-column-icons"
                    :class="{ 'border-green': retiredConfirmation}"
                  >
                    <div></div>
                    <div>
                      <font-awesome-icon
                        v-if="locationInfoDifferent"
                        :icon="['fas', 'exclamation-circle']"
                        size="lg"
                        style="color: #D13241"
                      />
                    </div>
                    <div>
                      <font-awesome-icon
                        v-if="showLocationInformation"
                        :icon="['far', 'caret-up']"
                        style="cursor: pointer; font-size: 1.25rem; color: #5953A4"
                        @click="toggleLocationInformation()"
                      />
                      <font-awesome-icon
                        v-else
                        :icon="['far', 'caret-down']"
                        size="lg"
                        style="cursor: pointer; font-size: 1.25rem; color: #5953A4"
                        @click="toggleLocationInformation()"
                      />
                    </div>
                  </td>
                </tr>
                <tr v-if="showLocationInformation">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      Person Type
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.personType, mergeStudent.personType)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ mapPersonType(retireStudent.personType) }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.personType, mergeStudent.personType)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mapPersonType(mergeStudent.personType) }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showLocationInformation && fieldEnabled('SCHOOL_YEAR')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('SCHOOL_YEAR') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.schoolYear, mergeStudent.schoolYear)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudent.schoolYear }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.schoolYear, mergeStudent.schoolYear)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudent.schoolYear }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showLocationInformation && fieldEnabled('DISTRICT_CODE')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('DISTRICT_CODE') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.districtCode, mergeStudent.districtCode)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudent.districtCode }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.districtCode, mergeStudent.districtCode)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudent.districtCode }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showLocationInformation && fieldEnabled('SCHOOL_CODE')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('SCHOOL_CODE') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.schoolCode, mergeStudent.schoolCode)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudent.schoolCode }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.schoolCode, mergeStudent.schoolCode)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudent.schoolCode }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showLocationInformation && fieldEnabled('RES_DISTRICT_CODE')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('RES_DISTRICT_CODE') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.resDistrictCode, mergeStudent.resDistrictCode)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudent.resDistrictCode }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.resDistrictCode, mergeStudent.resDistrictCode)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudent.resDistrictCode }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showLocationInformation && fieldEnabled('LOCAL_STUDENT_ID')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('LOCAL_STUDENT_ID') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.localId, mergeStudent.localId)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudent.localId }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.localId, mergeStudent.localId)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudent.localId }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showLocationInformation && fieldEnabled('SOURCE_CODE')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('SOURCE_CODE') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.sourceCode, mergeStudent.sourceCode)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ mapSource(retireStudent.sourceCode) }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.sourceCode, mergeStudent.sourceCode)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mapSource(mergeStudent.sourceCode) }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showLocationInformation && fieldEnabled('ALT_STUDENT_ID')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('ALT_STUDENT_ID') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.altStudentId, mergeStudent.altStudentId)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudent.altStudentId }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.altStudentId, mergeStudent.altStudentId)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudent.altStudentId }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showLocationInformation && fieldEnabled('ALT_SOURCE_SIS_CODE')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('ALT_SOURCE_SIS_CODE') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudent.altSourceSisCode, mergeStudent.altSourceSisCode
                        ) : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ mapSource(retireStudent.altSourceSisCode) }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudent.altSourceSisCode, mergeStudent.altSourceSisCode
                        ) : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mapSource(mergeStudent.altSourceSisCode) }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showLocationInformation && fieldEnabled('ACTIVE')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('ACTIVE') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudentLocInfo.active, mergeStudentLocInfo.active)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudentLocInfo.active === true ? 'Active' : 'Inactive' }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudentLocInfo.active, mergeStudentLocInfo.active)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudent.active === true ? 'Active' : 'Inactive' }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showLocationInformation && fieldEnabled('SOURCE_REFRESH_DATE')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('SOURCE_REFRESH_DATE') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          datePortion(retireStudentLocInfo.sourceRefreshDate),
                          datePortion(mergeStudentLocInfo.sourceRefreshDate)
                        ) : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudentLocInfo.sourceRefreshDate | formatDatePreserveZone }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          datePortion(retireStudentLocInfo.sourceRefreshDate),
                          datePortion(mergeStudentLocInfo.sourceRefreshDate)
                        ) : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudentLocInfo.sourceRefreshDate | formatDatePreserveZone }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showLocationInformation && fieldEnabled('LOCATION_COMMENT')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('LOCATION_COMMENT') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudentLocInfo.locationComment, mergeStudentLocInfo.locationComment
                        )
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudentLocInfo.locationComment }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudentLocInfo.locationComment, mergeStudentLocInfo.locationComment
                        ) : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudentLocInfo.locationComment }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showLocationInformation && fieldEnabled('GRADE_CODE')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('GRADE_CODE') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudentLocInfo.gradeCode, mergeStudentLocInfo.gradeCode
                        ) : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ mapGrade(retireStudentLocInfo.gradeCode) }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudentLocInfo.gradeCode, mergeStudentLocInfo.gradeCode
                        ) : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mapGrade(mergeStudentLocInfo.gradeCode) }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showLocationInformation && fieldEnabled('HIRE_DATE')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('HIRE_DATE') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudentLocInfo.hireDate, mergeStudentLocInfo.hireDate)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudentLocInfo.hireDate }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudentLocInfo.hireDate, mergeStudentLocInfo.hireDate)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudentLocInfo.hireDate }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showLocationInformation && fieldEnabled('SALARY')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('SALARY') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudentLocInfo.salary, mergeStudentLocInfo.salary
                        ) : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{
                        retireStudentLocInfo.salary ?
                          (retireStudentLocInfo.salary).toLocaleString(
                            'en-US', {
                              style: 'currency',
                              currency: 'USD',
                            }
                          ) : null
                      }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudentLocInfo.salary, mergeStudentLocInfo.salary
                        ) : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{
                        mergeStudentLocInfo.salary ?
                          (mergeStudentLocInfo.salary).toLocaleString(
                            'en-US', {
                              style: 'currency',
                              currency: 'USD',
                            }
                          ) : null
                      }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showLocationInformation && fieldEnabled('JOB_CLASS_CODE')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('JOB_CLASS_CODE') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudentLocInfo.jobClassCode, mergeStudentLocInfo.jobClassCode
                        ) : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ mapJobClassCode(retireStudentLocInfo.jobClassCode) }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudentLocInfo.jobClassCode, mergeStudentLocInfo.jobClassCode
                        ) : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mapJobClassCode(mergeStudentLocInfo.jobClassCode) }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showLocationInformation && fieldEnabled('JOB_ASSIGNMENT_1')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('JOB_ASSIGNMENT_1') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudentLocInfo.jobAssignment1, mergeStudentLocInfo.jobAssignment1
                        ) : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ mapJobAssignments(retireStudentLocInfo.jobAssignment1) }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudentLocInfo.jobAssignment1, mergeStudentLocInfo.jobAssignment1
                        ) : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mapJobAssignments(mergeStudentLocInfo.jobAssignment1) }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showLocationInformation && fieldEnabled('JOB_ASSIGNMENT_2')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('JOB_ASSIGNMENT_2') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudentLocInfo.jobAssignment2, mergeStudentLocInfo.jobAssignment2
                        ) : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ mapJobAssignments(retireStudentLocInfo.jobAssignment2) }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudentLocInfo.jobAssignment2, mergeStudentLocInfo.jobAssignment2
                        ) : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mapJobAssignments(mergeStudentLocInfo.jobAssignment2) }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showLocationInformation && fieldEnabled('JOB_ASSIGNMENT_3')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('JOB_ASSIGNMENT_3') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudentLocInfo.jobAssignment3, mergeStudentLocInfo.jobAssignment3
                        ) : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ mapJobAssignments(retireStudentLocInfo.jobAssignment3) }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudentLocInfo.jobAssignment3, mergeStudentLocInfo.jobAssignment3
                        ) : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mapJobAssignments(mergeStudentLocInfo.jobAssignment3) }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showLocationInformation && fieldEnabled('ITINERANT_FLAG')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('ITINERANT_FLAG') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudentLocInfo.itinerantFlag, mergeStudentLocInfo.itinerantFlag
                        ) : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ mapItinerantFlag(retireStudentLocInfo.itinerantFlag) }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudentLocInfo.itinerantFlag, mergeStudentLocInfo.itinerantFlag
                        ) : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mapItinerantFlag(mergeStudentLocInfo.itinerantFlag) }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="compare-panel-heading-bg-color has-text-weight-bold">
                    Credential Information
                  </td>
                  <td class="compare-panel-heading-bg-color text-align--center">
                    <font-awesome-icon
                      v-if="credentialInfoDifferent"
                      :icon="['fas', 'exclamation-circle']"
                      size="lg"
                      style="color: #D13241"
                    />
                    <div v-if="!mergeStudent" class="align--end">
                      <font-awesome-icon
                        v-if="showCredentialInformation"
                        :icon="['far', 'caret-up']"
                        style="cursor: pointer; font-size: 1.25rem; color: #5953A4"
                        @click="toggleCredentialInformation()"
                      />
                      <font-awesome-icon
                        v-else
                        :icon="['far', 'caret-down']"
                        size="lg"
                        style="cursor: pointer; font-size: 1.25rem; color: #5953A4"
                        @click="toggleCredentialInformation()"
                      />
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column compare-panel-heading-bg-color"/>
                  <td
                    v-if="mergeStudent"
                    class="compare-panel-heading-bg-color right-column-icons"
                    :class="{ 'border-green': retiredConfirmation}"
                  >
                    <div></div>
                    <div>
                      <font-awesome-icon
                        v-if="credentialInfoDifferent"
                        :icon="['fas', 'exclamation-circle']"
                        size="lg"
                        style="color: #D13241"
                      />
                    </div>
                    <div>
                      <font-awesome-icon
                        v-if="showCredentialInformation"
                        :icon="['far', 'caret-up']"
                        style="cursor: pointer; font-size: 1.25rem; color: #5953A4"
                        @click="toggleCredentialInformation()"
                      />
                      <font-awesome-icon
                        v-else
                        :icon="['far', 'caret-down']"
                        size="lg"
                        style="cursor: pointer; font-size: 1.25rem; color: #5953A4"
                        @click="toggleCredentialInformation()"
                      />
                    </div>
                  </td>
                </tr>
                <tr v-if="showCredentialInformation && fieldEnabled('HIGHEST_DEGREE')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('HIGHEST_DEGREE') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.highestDegree, mergeStudent.highestDegree)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudent.highestDegree }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.highestDegree, mergeStudent.highestDegree)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudent.highestDegree }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showCredentialInformation && fieldEnabled('SUBJECT_MATTER_AREA')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('SUBJECT_MATTER_AREA') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudent.subjectMatterArea, mergeStudent.subjectMatterArea
                        )
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudent.subjectMatterArea }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudent.subjectMatterArea, mergeStudent.subjectMatterArea
                        )
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudent.subjectMatterArea }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showCredentialInformation && fieldEnabled('DEGREE_PROVIDER')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('DEGREE_PROVIDER') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.degreeProvider, mergeStudent.degreeProvider)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudent.degreeProvider }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.degreeProvider, mergeStudent.degreeProvider)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudent.degreeProvider }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showCredentialInformation && fieldEnabled('CERTIFICATE_NUMBER')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('cerTIFICATE_NUMBER') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudent.certificateNumber, mergeStudent.certificateNumber
                        )
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudent.certificateNumber }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudent.certificateNumber, mergeStudent.certificateNumber
                        )
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudent.certificateNumber }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showCredentialInformation && fieldEnabled('CERTIFICATE_TYPE')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('CERTIFICATE_TYPE') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.certificateType, mergeStudent.certificateType)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudent.certificateType }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.certificateType, mergeStudent.certificateType)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudent.certificateType }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="compare-panel-heading-bg-color has-text-weight-bold">
                    Other Information
                  </td>
                  <td class="compare-panel-heading-bg-color text-align--center">
                    <font-awesome-icon
                      v-if="otherInfoDifferent"
                      :icon="['fas', 'exclamation-circle']"
                      size="lg"
                      style="color: #D13241"
                    />
                    <div v-if="!mergeStudent" class="align--end">
                      <font-awesome-icon
                        v-if="showOtherInformation"
                        :icon="['far', 'caret-up']"
                        style="cursor: pointer; font-size: 1.25rem; color: #5953A4"
                        @click="toggleOtherInformation()"
                      />
                      <font-awesome-icon
                        v-else
                        :icon="['far', 'caret-down']"
                        size="lg"
                        style="cursor: pointer; font-size: 1.25rem; color: #5953A4"
                        @click="toggleOtherInformation()"
                      />
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column compare-panel-heading-bg-color"/>
                  <td
                    v-if="mergeStudent"
                    class="compare-panel-heading-bg-color right-column-icons"
                    :class="{ 'border-green': retiredConfirmation}"
                  >
                    <div></div>
                    <div>
                      <font-awesome-icon
                        v-if="otherInfoDifferent"
                        :icon="['fas', 'exclamation-circle']"
                        size="lg"
                        style="color: #D13241"
                      />
                    </div>
                    <div>
                      <font-awesome-icon
                        v-if="showOtherInformation"
                        :icon="['far', 'caret-up']"
                        style="cursor: pointer; font-size: 1.25rem; color: #5953A4"
                        @click="toggleOtherInformation()"
                      />
                      <font-awesome-icon
                        v-else
                        :icon="['far', 'caret-down']"
                        size="lg"
                        style="cursor: pointer; font-size: 1.25rem; color: #5953A4"
                        @click="toggleOtherInformation()"
                      />
                    </div>
                  </td>
                </tr>
                <tr v-if="showOtherInformation && fieldEnabled('BIRTH_LOCATION')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('BIRTH_LOCATION') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.birthLocation, mergeStudent.birthLocation)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudent.birthLocation }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.birthLocation, mergeStudent.birthLocation)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudent.birthLocation }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showOtherInformation && fieldEnabled('RESIDENCY_STATUS')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('RESIDENCY_STATUS') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.residencyStatus, mergeStudent.residencyStatus)
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ mapResidencyStatus(retireStudent.residencyStatus) }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(retireStudent.residencyStatus, mergeStudent.residencyStatus)
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mapResidencyStatus(mergeStudent.residencyStatus) }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showOtherInformation && fieldEnabled('RESIDENCY_EXPIRATION_DATE')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('RESIDENCY_EXPIRATION_DATE') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudent.residencyExpirationDate,
                          mergeStudent.residencyExpirationDate
                        ) : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudent.residencyExpirationDate }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudent.residencyExpirationDate,
                          mergeStudent.residencyExpirationDate
                        ) : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudent.residencyExpirationDate }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showOtherInformation && fieldEnabled('MOTHERS_MAIDEN_NAME')">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      {{ fieldLabel('MOTHERS_MAIDEN_NAME') }}
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudent.mothersMaidenName, mergeStudent.mothersMaidenName
                        )
                        : false,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div class="cell-content">
                      {{ retireStudent.mothersMaidenName }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{
                      'panel--highlighted': mergeStudent
                        ? compareFields(
                          retireStudent.mothersMaidenName, mergeStudent.mothersMaidenName
                        )
                        : false,
                      'border-green': retiredConfirmation
                    }"
                  >
                    <div class="cell-content">
                      {{ mergeStudent.mothersMaidenName }}
                    </div>
                  </td>
                </tr>

                <!-- <tr>
                  <td class="compare-panel-heading-bg-color has-text-weight-bold">
                    Transaction Information
                  </td>
                  <td class="compare-panel-heading-bg-color"/>
                  <td v-if="mergeStudent" class="blank-column compare-panel-heading-bg-color"/>
                  <td
                    v-if="mergeStudent"
                    class="compare-panel-heading-bg-color"
                    :class="{ 'border-green': retiredConfirmation}"
                  />
                </tr> -->
                <!-- <tr>
                  <td class="compare-panel-heading-bg-color has-text-weight-bold">
                    Matching Information
                  </td>
                  <td class="compare-panel-heading-bg-color"/>
                  <td v-if="mergeStudent" class="blank-column compare-panel-heading-bg-color"/>
                  <td
                    v-if="mergeStudent"
                    class="compare-panel-heading-bg-color"
                    :class="{ 'border-green': retiredConfirmation}"
                  />
                </tr> -->
                <tr>
                  <td class="compare-panel-heading-bg-color has-text-weight-bold">
                    History Information
                  </td>
                  <td class="compare-panel-heading-bg-color text-align--center">
                    <div v-if="!mergeStudent" class="align--end">
                      <font-awesome-icon
                        v-if="showHistoryInformation"
                        :icon="['far', 'caret-up']"
                        style="cursor: pointer; font-size: 1.25rem; color: #5953A4"
                        @click="toggleHistoryInformation()"
                      />
                      <font-awesome-icon
                        v-else
                        :icon="['far', 'caret-down']"
                        size="lg"
                        style="cursor: pointer; font-size: 1.25rem; color: #5953A4"
                        @click="toggleHistoryInformation()"
                      />
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column compare-panel-heading-bg-color"/>
                  <td
                    v-if="mergeStudent"
                    class="compare-panel-heading-bg-color right-column-icons"
                    :class="{ 'border-green': retiredConfirmation}"
                  >
                    <div></div>
                    <div>
                      <font-awesome-icon
                        v-if="showHistoryInformation"
                        :icon="['far', 'caret-up']"
                        style="cursor: pointer; font-size: 1.25rem; color: #5953A4"
                        @click="toggleHistoryInformation()"
                      />
                      <font-awesome-icon
                        v-else
                        :icon="['far', 'caret-down']"
                        size="lg"
                        style="cursor: pointer; font-size: 1.25rem; color: #5953A4"
                        @click="toggleHistoryInformation()"
                      />
                    </div>
                  </td>
                </tr>
                <tr v-if="showHistoryInformation">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      Number of History Records
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{ 'panel--greyy': retiredConfirmation }"
                  >
                    <div class="cell-content">
                      {{ retireStudentHistInfo.totalCount }}
                    </div>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left vertical-align--bottom"
                    :class="{ 'border-green': retiredConfirmation }"
                  >
                    <div class="cell-content">
                      {{ mergeStudentHistInfo.totalCount }}
                    </div>
                  </td>
                </tr>
                <tr v-if="showHistoryInformation">
                  <td class="compare-panel-field-cell">
                    <div class="submission-header has-text-left">
                      History Records
                    </div>
                  </td>
                  <td
                    class="compare-panel-field-cell border--left"
                    :class="{
                      'vertical-align--top': retireStudentHistInfo.data.length,
                      'vertical-align--middle': !retireStudentHistInfo.data.length,
                      'panel--greyy': retiredConfirmation,
                    }"
                  >
                    <div v-if="!retireStudentHistInfo.data.length" style="text-align: center">
                      <es-exception
                        margin="0rem"
                        exceptionMessage="No History records."
                      />
                    </div>
                    <table role="presentation" v-else>
                      <thead>
                        <tr>
                          <td scope="col" class="date-width">
                            Update Date
                          </td>
                          <td scope="col" >
                            Name
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(record, index) in retireStudentHistInfo.data"
                          :key="index"
                          class="border--bottom"
                        >
                          <td>
                            {{ record.lastUpdateDate | formatDate }}
                          </td>
                          <td class="name-cell">
                            <strong>
                              {{ record.lastName }}, {{ record.firstName }} {{ record.middleName }}
                            </strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td v-if="mergeStudent" class="blank-column border--left"/>
                  <td v-if="mergeStudent"
                    class="compare-panel-field-cell border--left"
                    :class="{
                      'vertical-align--top': mergeStudentHistInfo.data.length,
                      'vertical-align--middle': !mergeStudentHistInfo.data.length,
                      'border-green': retiredConfirmation,
                    }"
                  >
                    <div v-if="!mergeStudentHistInfo.data.length" style="text-align: center">
                      <es-exception
                        margin="0rem"
                        exceptionMessage="No History records."
                      />
                    </div>
                    <table role="presentation" v-else>
                      <thead>
                        <tr>
                          <td scope="col" class="date-width">
                            Update Date
                          </td>
                          <td scope="col" >
                            Name
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(record, index) in mergeStudentHistInfo.data"
                          :key="index"
                          class="border--bottom"
                        >
                          <td>
                            {{ record.lastUpdateDate | formatDate }}
                          </td>
                          <td class="name-cell">
                            <strong>
                              {{ record.lastName }}, {{ record.firstName }} {{ record.middleName }}
                            </strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          v-if="!retiredConfirmation"
          class="is-flex flex-justify--end flex-align--center user-actions"
          id="bottom-actions"
        >
          <div v-if="mergeStudent">
            <button
              class="button button-link has-underline"
              @click="returnToList"
            >
              Cancel and Return to List
            </button>
            <button
              class="button button-link has-underline"
              :disabled="!hasRetireIdNoMergePermission"
              @click='goToConfirmationPage(false)'
            >
              Retire ID with No Merge
            </button>
            <button
              class="button is-primary"
              :disabled="!hasRetireIdMergePermission || !hasRetireIdNoMergePermission"
              @click="goToConfirmationPage(true)"
            >
              Retire ID and Merge Records
            </button>
          </div>
          <div v-else>
            <button
              class="button button-link has-underline"
              @click="returnToList"
            >
              Cancel and Return to List
            </button>
            <button
              class="button is-primary"
              @click="goToConfirmationPage(false)"
            >
              Retire ID with No Merge
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faMerge,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faCaretUp,
  faCaretDown,
} from '@fortawesome/pro-regular-svg-icons';
import EsException from '@/components/EsException.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import FieldLabels from '@/mixins/FieldLabels';
import NotificationManager from '@/mixins/NotificationManager';
import StateIdUtils from '@/mixins/StateIdUtils';
import LookupsUtils from '@/mixins/LookupsUtils';
import AccessibilityUtils from '@/mixins/AccessibilityUtils';

library.add(
  faCaretUp,
  faCaretDown,
  faMerge,
);

function myFunction() {
  const footer = document.getElementById('bottom-actions');
  if (footer !== null) {
    footer.classList.add('static-bottom');
  }
}

window.onscroll = myFunction();

export default {
  mixins: [
    FieldLabels,
    NotificationManager,
    StateIdUtils,
    LookupsUtils,
    AccessibilityUtils,
  ],
  components: {
    EsException,
    EsHeader,
    EsLoader,
  },
  props: {
    groupId: {
      type: Number,
    },
    loadingIdError: {
      type: Boolean,
    },
    loadingIdErrorMsg: {
      type: String,
    },
    mergePerson: {
      type: Object,
    },
    mergePersonHistInfo: {
      type: Object,
    },
    mergePersonLocInfo: {
      type: Object,
    },
    queueId: {
      type: Number,
    },
    retirePerson: {
      type: Object,
    },
    retirePersonHistInfo: {
      type: Object,
    },
    retirePersonLocInfo: {
      type: Object,
    },
    retiredConfirmation: {
      type: Boolean,
    },
    retiredResult: {
      type: Object,
    },
    hasRetireIdMergePermission: {
      type: Boolean,
      default: true,
    },
    hasRetireIdNoMergePermission: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    otherId() {
      this.loadNextPerson();
    },
  },
  created() {
    this.onLoad();
    this.itinerantFlagOptions = [
      {
        code: '1',
        description: 'Yes',
      },
      {
        code: '0',
        description: 'No',
      },
    ];
  },
  data() {
    return this.initialData();
  },
  computed: {
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
    ...mapGetters('lookups', [
      'activeEthnicities',
      'activeEthnicSubGroups',
      'activeGenders',
      'activeGrades',
      'activeJobAssignments',
      'activePersonTypes',
      'activeRaces',
      'activeResidencyStatuses',
      'activeSources',
      'activeStates',
      'activeTitles',
      'defaultPersonType',
    ]),
    ...mapGetters('fieldLabelsModule', [
      'getFieldLabelByPersonType',
      'getFieldEnabledForPersonType',
    ]),
    differentPersonTypes() {
      if (
        this.contextMode
        && this.retirePerson
        && this.mergePerson
        && (this.retirePerson.personType !== this.mergePerson.personType)
      ) {
        this.$emit('differentPersonTypes');
        return true;
      } return false;
    },
    contactInfoDifferent() {
      return this.isInfoDifferent([
        'street1',
        'street2',
        'city',
        'stateCode',
        'zip',
        'geocode',
      ]);
    },
    contextMode() {
      const identityControl = this.properties['IDENTITY_CONTROL-LIFETIME_IDS'];
      return JSON.parse(identityControl.toString().toLowerCase()) === false;
    },
    credentialInfoDifferent() {
      return this.isInfoDifferent([
        'highestDegree',
        'subjectMatterArea',
        'degreeProvider',
        'certificateNumber',
        'certificateType',
      ]);
    },
    locationInfoDifferent() {
      return this.isInfoDifferent([
        'personType',
        'schoolYear',
        'districtCode',
        'schoolCode',
        'resDistrictCode',
        'localId',
        'sourceCode',
        'altStudentId',
        'altSourceSisCode',
        'active',
        'sourceRefreshDate',
        'locationComment',
        'gradeCode',
        'hireDate',
        'salary',
        'jobClassCode',
        'jobAssignment1',
        'jobAssignment2',
        'jobAssignment3',
        'itinerantFlag',
      ]);
    },
    matchingFieldsInfoDifferent() {
      return this.isInfoDifferent([
        'firstName',
        'middleName',
        'lastName',
        'suffix',
        'previousLastName',
        'genderCode',
        'dateOfBirth',
        'socialSecurityNumber',
      ]);
    },
    otherInfoDifferent() {
      return this.isInfoDifferent([
        'birthLocation',
        'residencyStatus',
        'residencyExpirationDate',
        'certificateNumber',
        'mothersMaidenName',
      ]);
    },
    personInfoDifferent() {
      return this.isInfoDifferent([
        'ethnicityIndicator',
        'raceEthnicCode',
        'race2Code',
        'race3Code',
        'race4Code',
        'race5Code',
        'ethnicSubGroup',
        'fullName',
        'akaName',
      ]);
    },
  },
  methods: {
    ...mapActions('lookups', [
      'loadJobAssignments',
      'loadSources',
    ]),
    compareFields(retireInfo, mergeInfo) {
      if (retireInfo === mergeInfo) {
        return false;
      }
      return true;
    },
    datePortion(value) {
      // Normalize to the date portion only, ignoring any time component, so
      // date-only and datetime values for the same day compare as equal.
      // parseZone keeps the offset written in the value (e.g. "+05:30") rather
      // than converting to local time, so the date is not shifted by timezone.
      // Empty or invalid values normalize to null so two empties compare equal
      // and a garbage value never produces the literal "Invalid date" string.
      if (!value) return null;
      const m = moment.parseZone(value);
      return m.isValid() ? m.format('YYYY-MM-DD') : null;
    },
    fieldLabel(code) {
      return this.getFieldLabelByPersonType(code, 'ASSIGN', this.retireStudent.personType);
    },
    fieldEnabled(code) {
      return this.getFieldEnabledForPersonType(code, 'ASSIGN', this.retireStudent.personType);
    },
    goToConfirmationPage(mergeId) {
      this.$emit('viewRetireMergeConfirmationPage');
      this.$emit('retirePersonToConfirmationPage', this.retireStudent);
      if (mergeId) {
        this.$emit('mergePersonToConfirmationPage', this.mergeStudent);
      } else {
        this.$emit('mergePersonToConfirmationPage', null);
      }
    },
    isInfoDifferent(fieldsToCompare) {
      if (!this.mergeStudent) return false;
      return fieldsToCompare.some(
        field => this.compareFields(this.retireStudent[field], this.mergeStudent[field]),
      );
    },
    async loadOtherIds() {
      this.loading = true;
      this.loadingError = false;
      try {
        const response = await axios({
          method: 'get',
          url: `/idmanager/duplicates/${this.queueId}/groups/${this.groupId}/details`,
        });
        const temp = (response.data.filter(x => x.verifiedNoDup === false)).map(s => s.personId);
        this.remainingIds = temp.filter(i => i !== this.retireStudent.stateStudentId);
        if (!this.remainingIds.length) {
          this.mergeStudent = null;
        }
      } catch (e) {
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
    initialData() {
      return {
        formErrorMsg: 'There were some errors. Please fix the errors highlighted in the fields below.',
        hasErrorFields: false,
        itinerantFlagOptions: [],
        loading: false,
        loadingError: false,
        msgFields: null,
        mergeStudentMarkedNoDup: false,
        mergeStudent: this.mergePerson,
        mergeStudentHistInfo: this.mergePersonHistInfo,
        mergeStudentLocInfo: this.mergePersonLocInfo,
        otherId: null,
        remainingIds: [],
        retireStudent: this.retirePerson,
        retireStudentHistInfo: this.retirePersonHistInfo,
        retireStudentLocInfo: this.retirePersonLocInfo,
        showContactInformation: true,
        showCredentialInformation: true,
        showHistoryInformation: true,
        showLocationInformation: true,
        showMatchingFields: true,
        showModal: false,
        showOtherInformation: true,
        showPersonInformation: true,
        userPersonTypes: this.$store.state.user.userPersonTypes
          .map(item => item.personType).filter(a => a.status === true),
      };
    },
    async loadNextPerson() {
      this.loading = true;
      this.loadingError = false;
      try {
        const mergeResults = await axios.get(`person/${this.otherId}/profile`);
        this.mergeStudent = mergeResults.data;
        this.mergeStudentMarkedNoDup = false;
      } catch (error) {
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
    mapEthnicity(ethnicity) {
      return this.getDescriptionFromCode(ethnicity, this.activeEthnicities, ethnicity);
    },
    mapEthnicSubGroup(ethnicSubGroup) {
      return this.getDescriptionFromCode(
        ethnicSubGroup, this.activeEthnicSubGroups, ethnicSubGroup,
      );
    },
    mapGender(gender) {
      return this.getDescriptionFromCode(gender, this.activeGenders, gender);
    },
    mapGrade(grade) {
      return this.getDescriptionFromCode(grade, this.activeGrades, grade);
    },
    mapItinerantFlag(flag) {
      return this.getDescriptionFromCode(flag, this.itinerantFlagOptions, flag);
    },
    mapJobAssignments(code) {
      return this.getDescriptionFromCode(code, this.activeJobAssignments, code);
    },
    mapJobClassCode(code) {
      return this.getDescriptionFromCode(code, this.activeTitles, code);
    },
    mapPersonType(personType) {
      return this.getDescriptionFromCode(personType, this.activePersonTypes, personType);
    },
    mapRace(race) {
      return this.getDescriptionFromCode(race, this.activeRaces, race);
    },
    mapResidencyStatus(residencyStatus) {
      return this.getDescriptionFromCode(
        residencyStatus, this.activeResidencyStatuses, residencyStatus,
      );
    },
    mapSource(code) {
      return this.getDescriptionFromCode(code, this.activeSources, code);
    },
    mapState(stateCode) {
      return this.getDescriptionFromCode(stateCode, this.activeStates, stateCode);
    },
    async onLoad() {
      this.loading = true;
      this.loadingError = false;
      try {
        await Promise.all([
          this.loadJobAssignments(),
          this.loadSources(),
        ]);
      } catch (err) {
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
    async removeFromList() {
      this.toggleModal();
      this.loading = true;
      this.loadingError = false;
      const payload = {};
      payload.groupId = this.groupId;
      payload.verifiedNoDup = true;
      payload.personId = this.mergeStudent.stateStudentId;
      try {
        const response = await axios({
          method: 'put',
          url: `idmanager/duplicates/${this.queueId}/groups/${this.groupId}/details`,
          data: payload,
        });
        if (response.status === 200) {
          this.showNotification('success', [`State ID ${this.mergeStudent.stateStudentId} has been successfully marked as not duplicate.`]);
          this.mergeStudentMarkedNoDup = true;
          this.mergeStudent = {};
          this.loadOtherIds();
        }
      } catch (err) {
        this.showError(err.response.data.message);
        this.loadingError = false;
      } finally {
        this.loading = false;
      }
    },
    resetNotifications() {
      this.$store.state.notifications.isActive = false;
      this.$store.state.notifications.notificationType = null;
    },
    returnToList() {
      if (this.$route.path.includes('duplicateSearch')) {
        const record = JSON.parse(localStorage.getItem('GROUP'));
        this.$emit('groupInfo', record);
      }
      if (this.$route.path.includes('retireMergeIdDetails')) {
        this.$router.push({
          name: 'PIRetireMerge',
        });
      }
    },
    showError(error) {
      this.showNotification('danger', [error]);
    },
    switchTheData() {
      const temp = this.retireStudent;
      this.retireStudent = this.mergeStudent;
      this.mergeStudent = temp;
      const temp2 = this.retireStudentLocInfo;
      this.retireStudentLocInfo = this.mergeStudentLocInfo;
      this.mergeStudentLocInfo = temp2;
      const temp3 = this.retireStudentHistInfo;
      this.retireStudentHistInfo = this.mergeStudentHistInfo;
      this.mergeStudentHistInfo = temp3;
    },
    toggleContactInformation() {
      this.showContactInformation = !this.showContactInformation;
    },
    toggleCredentialInformation() {
      this.showCredentialInformation = !this.showCredentialInformation;
    },
    toggleHistoryInformation() {
      this.showHistoryInformation = !this.showHistoryInformation;
    },
    toggleLocationInformation() {
      this.showLocationInformation = !this.showLocationInformation;
    },
    toggleMatchingFields() {
      this.showMatchingFields = !this.showMatchingFields;
    },
    toggleModal() {
      this.showModal = !this.showModal;
      this.$nextTick(() => {
        const modalCloseFocus = this.$refs.btnNoDup;
        const modalOpenFocus = this.$refs.closeIcon;
        this.getFocusModal(modalOpenFocus, modalCloseFocus);
      });
    },
    toggleOtherInformation() {
      this.showOtherInformation = !this.showOtherInformation;
    },
    togglePersonInformation() {
      this.showPersonInformation = !this.showPersonInformation;
    },
  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(value).format('MM/DD/YYYY');
      }
      return 'N/A';
    },
  },
};
</script>

<style lang="sass" scoped>
  table
    width: 100%
  .table-header--sticky th,
  .table-header--sticky td
    position: sticky
    background-color: #ffffff
  .table-header--sticky th
    top: 126px
  .table-header--sticky td
    top: 170px
  th
    border-top: 1px solid #ccc
    vertical-align: middle
  .align--end
    text-align: end
  .border-green
    border-left: 3px solid #a9d18e !important
    border-right: 3px solid #a9d18e !important
  .blank-column
    width: 100px
  .border--bottom
    border-bottom: 1px solid #DEE2E6
  .border--left
    border-left: 1px solid #DEE2E6
  .button-link
    font-size: 12px
  .cell-content
    font-size: 16px
    font-weight: bold
    text-align: left
  .compare-panel
    max-width: 320px
    min-width: 320px
    padding: 1rem
  .compare-panel-field-cell
    padding-left: 1rem
  .compare-panel-heading-bg-color
    font-size: 12px
    background-color: #EEEEEE
  .date-width
    width: 35%
  .float-text
    position: absolute
    top: 25%
    text-transform: uppercase
    -webkit-transform: rotate(-45deg)
    transform: rotate(-45deg)
    font-size: 2rem
    color: #999
    z-index: 1
  .icon-cell
    border: 0
    color: #212529
    text-align: center !important
  th.label-merge
    background-color: #428316
    border: 0
    color: #FFFFFF
    text-align: center !important
  th.label-retire
    background-color: #595959
    border: 0
    color: #FFFFFF
    text-align: center !important
  .name-cell
    border-left: 1px solid #DEE2E6
  .modal-body
    margin-bottom: 1rem
    display: flex
    justify-content: flex-start
  .modal-card-body
    border-bottom-right-radius: .4rem
    border-bottom-left-radius: .4rem
    text-align: left
  .modal-card-head
    background-color: #F5F5F5
    text-align: left
  .modal-card-title
    margin-bottom: 0 !important
    color: #444
  .update-box
    display: flex
    align-items: center
    justify-content: flex-end
    button
      margin-left: 1rem
  .outer
    margin-left: auto
  .panel--greyy
    background-color: #F7F7F7
  .panel--highlighted
    background-color: rgb(255, 245, 214)
  .right-column-icons
    display: flex
    height: 37.5px
    justify-content: space-between
    align-items: center
  .state-id
    color: #343A40
    font-size: 16px
  .state-id-label
    color: #737373
    font-size: 12px
  .static-bottom
    bottom: 0
    position: sticky
  .submission-header
    color: #737373
    font-size: 12px
  .switch-label
    text-align: center
    vertical-align: middle
  .text-align--center
    text-align: center
  .user-actions
    margin-right: 1rem
    background: #FFF
    border-top: 1px solid #DEE2E6
    bottom: 0
    color: #F1F1F1
    padding: 10px 16px
    box-shadow: 0 2px 2px 0 #ccc
    position: sticky
  .vertical-align--bottom
    vertical-align: bottom
  .vertical-align--middle
    vertical-align: middle
  .vertical-align--top
    vertical-align: top
  .overflow-container
    overflow-x: auto
</style>
